import { TabularCopySink } from './../../../pipeline/copysink/tabular.copysink';
import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CopySinkAdapter } from './copysink.adapter';
import { Metamodel } from 'shell-models-lib';

export abstract class TabularSinkAdapter<T, U> extends CopySinkAdapter<T, U> {
    public static toSinkResource(model: TabularCopySink, resource: Model.CopySink): void {
        if (resource != null) {
            resource.writeBatchSize = ValueAdapter.toResource(model, Metamodel.modelOf(model).attribute('writeBatchSize'));
            const writeBatchTimeout = ValueAdapter.toResource(model, TabularCopySink.WRITE_BATCH_TIMEOUT);
            if (writeBatchTimeout != null && writeBatchTimeout !== '') {
                // don't need pass '' to backend
                resource.writeBatchTimeout = writeBatchTimeout;
            }
            const preCopyScript = ValueAdapter.toResource(model, TabularCopySink.PRE_COPY_SCRIPT);
            if (preCopyScript != null && preCopyScript !== '') {
                // don't need pass '' to backend
                resource.preCopyScript = preCopyScript;
            }
            CopySinkAdapter.maxConcurrentConnectionsToResource(model, resource);
        }
    }

    public static toSinkModel(resource: Model.CopySink, model: TabularCopySink): void {
        if (model != null) {
            ValueAdapter.toModel(model, Metamodel.modelOf(model).attribute('writeBatchSize'), resource.writeBatchSize);
            ValueAdapter.toModel(model, TabularCopySink.WRITE_BATCH_TIMEOUT, resource.writeBatchTimeout);
            ValueAdapter.toModel(model, TabularCopySink.PRE_COPY_SCRIPT, resource.preCopyScript);
            CopySinkAdapter.maxConcurrentConnectionsToModel(resource, model);
        }
    }
}
